export default __webpack_public_path__ + "media/library-default.f0fbaf99d73b26240d2c26fb21f0112e.webp";